import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const NotifyListAsyncAction = createAsyncThunk(
    "",
    async (data) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/notification/list", data, {
                headers: authHeader(false)
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);



const initialState = {
    notify_list: []
};


const NotificationSlice = createSlice({
    name: "notification",
    initialState,
    // reducers: {
    //     ResetCategroyList: (state) => {
    //         state.transaction_history = {};
    //     },
    //     ResetFAQList: (state) => {
    //         state.notify_list = {};
    //     },
    // },
    extraReducers: {
        [NotifyListAsyncAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [NotifyListAsyncAction.fulfilled]: (state, { payload }) => {
            return { ...state, notify_list: payload, loading: false };
        },
        [NotifyListAsyncAction.rejected]: (state) => {
            return { ...state, loading: false };
        }
    }
})

export default NotificationSlice.reducer;
